import React, { useEffect, useState } from "react";
import Line from "../../../assets/line2.svg";
import { IoPeople } from "react-icons/io5";
import { FaBuilding } from "react-icons/fa";
import { BsSuitcaseLgFill } from "react-icons/bs";
// import { TbBuildingBroadcastTowerFilled } from "react-icons/tb";
// import { TbBuildingEstate } from "react-icons/tb";
import { FiCopy } from "react-icons/fi";
import { BACKEND_API } from "../../../api/ApiConfig";
import accurate from "../../../assets/new/icon_user_friendly_interface.svg"
import processing from "../../../assets/new/icon_verification_steps.svg"
import process from "../../../assets/new/icon_versatile_search.svg"

export default function EmailFinder() {
  const [activeButton, setActiveButton] = useState("byName");
  const [copiedMessage1, setCopiedMessage1] = useState(false);
  const [copiedMessage2, setCopiedMessage2] = useState(false);
  const [results, setResults] = useState();
  const [requestData, setRequestData] = useState(null);
  const [endpoint, setEndpoint] = useState("");

  useEffect(() => {
    fetchData(activeButton);
  }, [activeButton]);

  const fetchData = (type) => {
    let data = {};
    let apiEndpoint = "";
    let mockResults = {};

    if (type === "byName") {
      data = {
        domain: "exactmails.com",
        username: "Joe d'Elia",
      };
      apiEndpoint = `${BACKEND_API}/email/find-person-email/`;
      mockResults = {
        message: "Emails found successfully.",
        emails: {
          email: "Joe.Elia@exactmails.com",
          status: "safe",
          success_rate: 98.0,
          is_safe_to_send: true,
          is_valid_syntax: true,
          can_connect_smtp: true,
        },
      };
    } else if (type === "byCompany") {
      data = {
        linkedin_url: "https://www.linkedin.com/in/mike.waite/",
      };
      apiEndpoint = `${BACKEND_API}/email/linkedin-profile`;
      mockResults = {
        message: "Emails found successfully.",
        emails: {
          email: "mike.waite@abbottnutrition.com",
          status: "safe",
          success_rate: 98.0,
          is_safe_to_send: true,
          is_valid_syntax: true,
          can_connect_smtp: true,
        },
        username: "mike waite",
        company_name: "Abbott Nutrition",
        company_url: "https://www.abbottnutrition.com/",
      };
    } else if (type === "byDecisionMaker") {
      data = {
        file_name: "my_bulk.csv",
        decision_maker_category: "ceo",
      };
      apiEndpoint = `${BACKEND_API}/email/find-bulk-decision-maker`;
      mockResults = {
        message: "Emails found successfully.",
        emails: [
          {
            email: "sarah.jane@abbottnutrition.com",
            status: "safe",
            success_rate: 98.0,
            is_safe_to_send: true,
            is_valid_syntax: true,
            can_connect_smtp: true,
          },
          {
            email: "john.doe@company.com",
            status: "safe",
            success_rate: 95.0,
            is_safe_to_send: true,
            is_valid_syntax: true,
            can_connect_smtp: true,
          },
        ],
        created_at: "2024-07-16T08:13:03.335Z",
        credits_needed: 5,
        decision_maker_category: "ceo",
        file_name: "my_bulk.csv",
        id: "blk_123456",
        paid: false,
        started_running_at: "2024-07-16T08:13:03.335Z",
        status: "running",
        success: true,
      };
    }

    setRequestData(data);
    setEndpoint(apiEndpoint);
    setResults(mockResults);
  };

  const handleButtonClick = (type) => {
    setActiveButton(type);
    fetchData(type);
  };

  const copyToClipboard = (text, isSecondBlock = false) => {
    navigator.clipboard.writeText(text);
    if (isSecondBlock) {
      setCopiedMessage2(true);
      setTimeout(() => setCopiedMessage2(false), 2000);
    } else {
      setCopiedMessage1(true);
      setTimeout(() => setCopiedMessage1(false), 2000);
    }
  };

  return (
    <div className="bg-white pb-12 px-5 flex flex-col items-center mb-4">
      <div className="text-center w-full md:w-[90%] mb-8 mt-2 lg:mt-12">
        <h2 className="text-3xl sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold">
          Email Finder{" "}
          <span className="relative inline-block">
            API
            <img
              src={Line}
              alt="Underline decoration"
              className="absolute bottom-0 left-0 w-full top-9 lg:top-[47px]"
            />
          </span>
        </h2>
      </div>

      <div className="flex flex-col lg:flex-row w-full gap-4 ">
        <div className="w-full lg:w-[70%] order-2 lg:order-1">
          <div className="mb-4 rounded-lg w-full">
            <div className="relative">
              <pre className="bg-black text-white p-4 h-40 lg:h-[160px] xl:h-[160px] rounded-xl overflow-y-auto overflow-x-auto scrollbar-hide">
                POST {endpoint}
                {"\n"}
                {JSON.stringify(requestData, null, 2)}
              </pre>
              <button
                onClick={() =>
                  copyToClipboard(
                    `POST ${endpoint}\n${JSON.stringify(requestData, null, 2)}`
                  )
                }
                className="absolute top-2 right-2 m-2 text-white bg-gray-500 p-2 rounded-full"
              >
                <FiCopy />
              </button>
              {copiedMessage1 && (
                <span className="absolute top-4 right-16 text-white bg-green-500 px-2 py-1 rounded-md">
                  Copied!
                </span>
              )}
            </div>
          </div>

          <div className="rounded-lg w-full">
            <div className="relative">
              <div className="flex items-center bg-[#19253C] p-4 rounded-t-xl border-b-[1px] border-gray-500">
                <span className="bg-green-500 text-white px-3 py-1 rounded-lg mr-2">
                  200 - OK
                </span>
                <button
                  onClick={() =>
                    copyToClipboard(JSON.stringify(results, null, 2), true)
                  }
                  className="ml-auto text-white bg-gray-500 p-2 rounded-full"
                >
                  <FiCopy />
                </button>
              </div>
              {copiedMessage2 && (
                <span className="absolute top-4 right-16 text-white bg-green-500 px-2 py-1 rounded-md">
                  Copied!
                </span>
              )}
              <pre className="bg-[#19253C] lg:h-[360px] min-[1090px]:h-[340px] min-[1160px]:h-[330px] min-[1280px]:h-[200px] text-white p-4 rounded-b-xl overflow-y-auto overflow-x-auto scrollbar-hide">
                {JSON.stringify(results, null, 2)}
              </pre>
            </div>
          </div>
        </div>

        <div className="w-full lg:w-[30%] order-1 lg:order-2">
          <div className="bg-[#ecf3ff] rounded-t-lg lg:rounded-3xl scrollbar-hide lg:shadow-md lg:flex-col p-4 flex items-center space-x-3 sm:space-x-6 lg:space-x-0 mb-4 lg:space-y-4 sm:justify-center overflow-x-auto whitespace-nowrap lg:whitespace-normal">
            <h2 className="text-lg font-semibold text-center hidden lg:block">
              Find Emails
            </h2>
            <p className="text-gray-600 text-center hidden lg:block">
              Use the options below to see examples of finding emails by:
            </p>
            <button
              onClick={() => handleButtonClick("byName")}
              className={`flex lg:hidden items-center border-b-2 pb-1 ${
                activeButton === "byName"
                  ? "text-[#4f7fff] border-[#4f7fff]"
                  : "text-gray-600 border-transparent"
              } hover:text-[#4f7fff]`}
              aria-label="Find Emails by Name"
            >
              <IoPeople className="h-5 mr-1" />
              Find Emails by Name
            </button>
            <button
              onClick={() => handleButtonClick("byCompany")}
              className={`flex lg:hidden items-center border-b-2 pb-1 ${
                activeButton === "byCompany"
                  ? "text-[#4f7fff] border-[#4f7fff]"
                  : "text-gray-600 border-transparent"
              } hover:text-[#4f7fff]`}
              aria-label="Find Emails by Company"
            >
              <FaBuilding className="h-5 mr-1" />
              Find Emails by Company
            </button>
            <button
              onClick={() => handleButtonClick("byDecisionMaker")}
              className={`flex lg:hidden items-center border-b-2 pb-1 ${
                activeButton === "byDecisionMaker"
                  ? "text-[#7080ac] border-[#4f7fff]"
                  : "text-gray-600 border-transparent"
              } hover:text-[#4f7fff]`}
              aria-label="Bulk Email Finder"
            >
              <BsSuitcaseLgFill className="h-5 mr-1" />
              Find Email in Bulk
            </button>

            <div className="lg:grid hidden lg:grid-cols-2 xl:grid-cols-3 gap-4">
              <div
                className={`relative rounded-3xl ${
                  activeButton === "byName" ? "bg-slate-50" : "bg-white"
                } p-4 w-[105px] h-[110px]`}
              >
                <div className="absolute top-2 left-2 bg-gray-200 rounded-full p-2.5">
                  <IoPeople className="text-gray-500" />
                </div>
                <button
                  onClick={() => handleButtonClick("byName")}
                  className={`flex items-center justify-center w-full h-full text-center text-[12px] ${
                    activeButton === "byName"
                      ? "text-[#4f7fff]"
                      : "bg-white text-gray-600"
                  } rounded-3xl`}
                  aria-label="Find Emails by Name"
                >
                  <span className="-mb-10 -ml-1 text-left">
                    Find Emails by Name
                  </span>
                </button>
              </div>

              <div
                className={`relative rounded-3xl ${
                  activeButton === "byCompany" ? "bg-slate-50" : "bg-white"
                } p-4 w-[105px] h-[110px]`}
              >
                <div className="absolute top-2 left-2 bg-gray-200 rounded-full p-2.5">
                  <FaBuilding className="text-gray-500" />
                </div>
                <button
                  onClick={() => handleButtonClick("byCompany")}
                  className={`flex items-center justify-center w-full h-full text-center text-[12px] ${
                    activeButton === "byCompany"
                      ? "text-[#4f7fff]"
                      : "bg-white text-gray-600"
                  } rounded-3xl`}
                  aria-label="Find Emails by Company"
                >
                  <span className="-mb-9 -ml-1 text-left">
                    Find Emails by Linkedin ID
                  </span>
                </button>
              </div>

              <div
                className={`relative rounded-3xl ${
                  activeButton === "byDecisionMaker"
                    ? "bg-slate-50"
                    : "bg-white"
                } bg-white p-4 w-[105px] h-[110px]`}
              >
                <div className="absolute top-2 left-2 bg-gray-200 rounded-full p-2.5">
                  <BsSuitcaseLgFill className="text-gray-500" />
                </div>
                <button
                  onClick={() => handleButtonClick("byDecisionMaker")}
                  className={`flex items-center justify-center w-full h-full text-center text-[12px] ${
                    activeButton === "byDecisionMaker"
                      ? "text-[#4f7fff]"
                      : "bg-white text-gray-600"
                  } rounded-3xl`}
                  aria-label="Bulk"
                >
                  <span className="-mb-9 -ml-1 text-left">
                    Find Email in Bulk
                  </span>
                </button>
              </div>
            </div>

            <div className="lg:flex hidden w-full items-center space-x-2 bg-white rounded-full px-4 py-2">
              {/* <div className="rounded-full bg-gray-200 p-2 mr-2"> */}
                {/* <FaTextHeight className="text-gray-500" /> */}
              {/* </div> */}
              <img src={accurate} alt="Checkmark" className="mr-2 -mt-[1px] w-9 h-9" />
              <span className="text-gray-800 text-sm font-medium">
                Accurate email retrival
              </span>
            </div>
            <div className="lg:flex hidden w-full items-center space-x-2 bg-white rounded-full px-4 py-2">
              {/* <div className="rounded-full bg-gray-200 p-2 mr-2">
                <TbBuildingBroadcastTowerFilled className="text-gray-500" />
              </div> */}
              <img src={processing} alt="Checkmark" className="mr-2 -mt-[1px] w-9 h-9" />
              <span className="text-gray-800 text-sm font-medium">
                Bulk processing capability
              </span>
            </div>
            <div className="lg:flex hidden w-full items-center space-x-2 bg-white rounded-full px-4 py-2">
              {/* <div className="rounded-full bg-gray-200 p-2 mr-2">
                <TbBuildingEstate className="text-gray-500" />
              </div> */}
              <img src={process} alt="Checkmark" className="mr-2 -mt-[1px] w-9 h-9" />
              <span className="text-gray-800 text-sm font-medium">
                Seamless inteeration
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
